import '../scss/style.scss';
import Manager from './manager';

window.addEventListener('load', () => {
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'))
	}, 1000)
});

// 以前は window.load（全画像の読み込み完了）まで待っていたが、
// 重い画像があると演出の開始が遅れるため DOM 構築後に開始する
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', loadFinished);
} else {
	loadFinished();
}

function loadFinished() {
	const manager = new Manager();
	manager.init()
}
